import arrayMutators from 'final-form-arrays'
import {Form} from 'react-final-form'
import {useParams} from 'react-router-dom'

import {alertService} from '../../../../infra/utils/alerts'
import {useFormDirty} from '../../contexts/FormDirtyContext'
import {FormDirtyTracker} from '../FormDirtyTracker'
import ArticleDetailsTabs from '../article-details-tabs/ArticleDetailsTabs'
import ArticleProductCard from '../article-product-card/ArticleProductCard'
import {formatProductForForm} from './utils/formatProductForForm'
import {getEditedSections} from './utils/getEditedSections'
import {getProductMetrics} from './utils/getProductMetrics'
import {saveProduct} from './utils/saveProduct'

export const ArticlesDetailsForm = ({isLoading, product}) => {
  const {productId} = useParams()
  const {resetIsDirty, hasSavedImage, setHasSavedImage} = useFormDirty()

  const initialValues = formatProductForForm(product)

  const {grossMargin, lastAcquisition, baseValue, additionalPrice} =
    getProductMetrics(product)

  const handleFormSubmit = async (values, form) => {
    const dirtyFields = form.getState().dirtyFields

    const editedSections = getEditedSections(dirtyFields)

    try {
      await saveProduct(
        productId,
        values,
        editedSections,
        form,
        hasSavedImage,
        setHasSavedImage
      )
      alertService.success({
        heading: 'Success',
        message: 'Successfully saved product'
      })
      form.reset()
      resetIsDirty(form.getState().values)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Form
      onSubmit={(values, form) => handleFormSubmit(values, form)}
      mutators={{...arrayMutators}}
      keepDirtyOnReinitialize
      initialValues={initialValues}
      render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit}>
          {/* Tracks form dirty state */}
          <FormDirtyTracker />
          <ArticleProductCard
            product={product}
            margin={grossMargin}
            lastAcquisition={lastAcquisition}
            baseValue={baseValue}
            additionalPrice={additionalPrice}
            isSaving={submitting}
            animate={false}
            initialValues={initialValues}
          />
          <ArticleDetailsTabs isLoading={isLoading || !initialValues} />
        </form>
      )}
    />
  )
}
